
// === Frontend: React + TypeScript + Bootstrap ===
// File: ChatBot.tsx
import React, { useState } from 'react';
import axios from 'axios';
import { Form, Button, Spinner } from 'react-bootstrap';
import { FaBeer, FaBars  } from 'react-icons/fa';
import 'bootstrap-icons/font/bootstrap-icons.css';


const ChatBot: React.FC = () => {

const IconFaBeer = FaBeer as unknown as React.FC<React.SVGProps<SVGSVGElement>>;


  const [question, setQuestion] = useState('');
  const [answer, setAnswer] = useState('');
  const [loading, setLoading] = useState(false);

  const askQuestion = async () => {
    setLoading(true);
    try {
      const response = await axios.post('http://localhost:3001/api/question', { question });
      setAnswer(response.data.answer);
    } catch (error) {
      setAnswer('Error getting answer.');
    }
    setLoading(false);
  };

  return (
    <div className="container mt-5">
      {/* <h3><IconFaBeer className="me-2" /> Q&A ChatBot</h3> */}
      <h3><i className="bi bi-list"></i> Q&A ChatBot</h3>
      
      <Form.Group className="mb-3">
        <Form.Label>Ask a Question:</Form.Label>
        <Form.Control
          type="text"
          value={question}
          onChange={(e) => setQuestion(e.target.value)}
          placeholder="Type your question here..."
        />
      </Form.Group>
      <Button variant="primary" onClick={askQuestion} disabled={loading}>
        {loading ? <Spinner animation="border" size="sm" /> : 'Ask'}
      </Button>
      {answer && (
        <div className="mt-4 alert alert-info">
          <strong>Answer:</strong> {answer}
        </div>
      )}
    </div>
  );
};

export default ChatBot;